import styled from 'styled-components/macro';

// import theme helpers
import { getBreakpoint, getColor, getFontWeight } from '../../../../util/theme';

const CtaBarSubmit = styled.button`
  background-color: ${getColor('accentGreen')};

  border: 0;

  color: ${getColor('primaryBlue')};
  font-family: Roboto, sans-serif;
  font-weight: ${getFontWeight('medium')};
  font-size: 2rem;

  margin: 0 auto 10px auto;
  padding: 10px 0;

  width: 50%;

  position: absolute;
  bottom: -30px;
  left: 25%;

  cursor: pointer;

  transition: all 0.15s linear;

  @media (min-width: ${getBreakpoint('lg')}) {
    left: auto;
    width: 25%;
  }

  &:hover {
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    transform: translateY(-2px);
  }
`;

export default CtaBarSubmit;
